<template>
  <div>
    <div class="columns cards">
      <div class="column card is-blue">
        <div class="icon">
          <i class="fa fa-wallet"/>
        </div>

        <div class="card-content">
          <div v-if="this.$store.getters['contas/getContas']">
            <div class="title">R$ {{somarPatrimonio}}</div>
            <div class="subtitle">Patrimônio</div>
          </div>
          <div v-if="!this.$store.getters['contas/getContas']" class="loader"></div>
        </div>
      </div>

      <div class="column card is-purple">
        <div class="icon">
          <i class="fa fa-box"/>
        </div>

        <div class="card-content">
          <div v-if="this.$store.getters['associacao/getAssociacao']">
            <div class="title">{{qtdAssociados}}</div>
            <div class="subtitle">Associados</div>
          </div>
          <div v-if="!this.$store.getters['associacao/getAssociacao']" class="loader"></div>
        </div>
      </div>

      <div class="column card is-green">
        <div class="icon">
          <i class="fa fa-boxes"/>
        </div>

        <div class="card-content">
          <div v-if="this.$store.getters['contas/getContas']">
            <div class="title">R$ {{(parseFloat(valor_receitas) + parseFloat(valor_despesas)).toFixed(2)}}</div>
            <div class="subtitle">Saldo do Mês</div>
          </div>
          <div v-if="!this.$store.getters['contas/getContas']" class="loader"></div>
        </div>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-vertical is-8">
        <div class="tile">

          <div class="tile is-parent is-vertical">
            <article class="tile is-child notification">
              <p class="subtitle has-text-centered">Resumo Financeiro</p>
              <div class="content">
                <pie-chart :chartData="resumo_financeiro" :options="options" :height="250" :width="250"></pie-chart>
              </div>
            </article>
            <article class="tile is-child notification">
              <p class="subtitle has-text-centered">Principais Despesas</p>
              <div class="content">
                <pie-chart :chartData="resumo_despesas" :options="options" :height="250" :width="250"></pie-chart>
              </div>
            </article>
          </div>

          <div class="tile is-parent is-vertical">
            <article class="tile is-child notification">
              <p class="subtitle has-text-centered">Eventos</p>
              <div class="content"></div>
            </article>
            <article class="tile is-child notification">
              <p class="subtitle has-text-centered">Principais Receitas</p>
              <div class="content">
                <template>
                  <pie-chart :chartData="resumo_receitas" :options="options" :height="250" :width="250"></pie-chart>
                </template>
              </div>
            </article>
          </div>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child notification">
            <p class="subtitle has-text-centered">Estatísticas</p>
            <div class="content"></div>
          </article>
        </div>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification">
          <div class="content">
            <p class="subtitle has-text-centered">Atividades Recentes</p>
            <div class="content"></div>
          </div>
        </article>
      </div>
    </div>

    <!-- <div class="box">
      <div class="title is-5">Título da página</div>
      <div class="subtitle is-6">Subtítulo da página</div>

      <div class="content">Conteúdo da página</div>
    </div>

    <div class="box">
      <div class="title is-5">Input e botões</div>
      <div class="subtitle is-6">Apenas exemplos</div>

      <div class="content">
        <b-field label="Input (deixa vazio para mostrar o erro)">
          <b-input type="text" required/>
        </b-field>

        <button class="button is-success">Verde!</button>
        <button class="button is-danger">Vermelho!</button>
        <button class="button">Padrão!</button>
        <button class="button is-grey">Cinza!</button>
      </div>
    </div>

    <div class="column">
      <card-toggle title="Card toggle">Conteúdo do card</card-toggle>
    </div>-->
  </div>
</template>


<style lang="scss" scoped>
@import "./src/css/views/Dashboard";
</style>

<script>
import { mapGetters } from 'vuex';
import PieChart from "@/components/Charts/Pie"

export default {
  name: "Home",
  components: {
    PieChart
  },
  data() {
    return {
      contas: null,
      resumo_financeiro: null,
      resumo_despesas: null,
      resumo_receitas: null,
      options: {
        segmentShowStroke: false,
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  computed: {
    ...mapGetters({
      valor_receitas: 'estatisticasFinanceiras/getValorReceitas',
      valor_despesas: 'estatisticasFinanceiras/getValorDespesas',
      principais_receitas: 'estatisticasFinanceiras/getPrincipaisReceitas',
      principais_despesas: 'estatisticasFinanceiras/getPrincipaisDespesas',
    }),

    somarPatrimonio() {
      if (this.$store.getters["contas/getContas"]) {
        return this.$store.getters["contas/getContas"]
          .reduce((sum, conta) => {
            return sum + conta.saldo;
          }, 0)
          .toFixed(2);
      }
      return 0;
    },
    somarSaldoMes() {
      return 0;
      if (this.$store.getters["contas/getContas"]) {
        return (
          this.somarPatrimonio -
          this.$store.getters["contas/getContas"]
            .reduce((sum, conta) => {
              return sum + conta.saldo_anterior;
            }, 0)
            .toFixed(2)
        );
      }
      return 0;
    },
    qtdAssociados() {
      if (this.$store.getters["associacao/getAssociacao"])
        return this.$store.getters["associacao/getAssociacao"].socios.ativos
          .length;
      return 0;
    }
  },

  methods: {
    async atualizarEstatisticas() {
      await this.$store.dispatch("estatisticasFinanceiras/getTransacoesDoMesInFirestore");
      this.resumo_financeiro = {
        labels: ["Receitas", "Despesas"],
        datasets: [
          {
            data: [this.valor_receitas, this.valor_despesas],
            backgroundColor: ["#a8ebcf", "#ec6d68"]
          }
        ]
      }
      this.resumo_despesas = {
        labels: ["Gratificações", "Serviços Contábeis", "Energia Elétrica"],
        datasets: [
          {
            data: [140, 60, 220],
            backgroundColor: ["#a8ebcf", "#e2b8b2", "#9CB7C2"],
          }
        ]
      }
      this.resumo_receitas = {
        labels: ["Mensalidades", "Repasses", "Doações"],
        datasets: [
          {
            data: [230, 440, 50],
            backgroundColor: ["#f9d371", "#d5eeea", "#e2b8b2"],
          }
        ]
      }
    }
  },

  mounted() {
    this.$store.dispatch("associacao/getAssociacaoInFirestore");
    this.$store.dispatch("contas/getContasInFirestore");
    this.atualizarEstatisticas();
  }
};
</script>